import React from 'react'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Modal.scss'
const rootClassName = 'component-modal-mask'
interface ModalMaskProps {
  className?: string
  mobileOnXS?: boolean
  children?: any
  onClick?: (event: any) => void
}
export const ModalMask = (props: ModalMaskProps) => {
  const getProps = () => {
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className || '',
        props.mobileOnXS ? 'mobile-on-xs' : ''
      ])
    }
    delete p.mobileOnXS
    return p
  }
  return <div {...getProps()}>{props.children}</div>
}
